import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      // Upload Screen
      appTitle: 'Excel Editor',
      uploadSubtitle: 'Excel dosyanızı yükleyin, verilerinizi görüntüleyin ve yönetin',
      dropText: 'Dosyayı buraya sürükleyin',
      dropOr: 'veya',
      selectFile: 'Dosya Seçin',
      supportedFiles: '.xlsx, .xls, .csv dosyaları desteklenir',
      readingFile: 'Dosya okunuyor...',
      invalidFileType: 'Lütfen geçerli bir Excel dosyası (.xlsx, .xls, .csv) yükleyin.',
      emptyFile: 'Excel dosyası boş veya okunamadı.',
      readError: 'Dosya okunurken hata oluştu: {{message}}',

      // Features
      featureTableTitle: 'Tablo Görünümü',
      featureTableDesc: 'Verilerinizi düzenli tablo olarak görüntüleyin',
      featureBarcodeTitle: 'Barkod Tarama',
      featureBarcodeDesc: 'Sütun bazında arama ve filtreleme yapın',
      featureSettingsTitle: 'Sütun Ayarları',
      featureSettingsDesc: 'Görmek istediğiniz sütunları özelleştirin',
      featureAutoSaveTitle: 'Otomatik Kayıt',
      featureAutoSaveDesc: 'Tüm veriler tarayıcıda güvenle saklanır',

      // Stats
      totalData: 'Toplam Veri',
      scanned: 'Taranan',
      notScanned: 'Taranmayan',

      // Toolbar
      deleteData: 'Verileri Sil',
      searchPlaceholder: 'Değer girip Enter\'a basın...',
      clear: 'Temizle',
      columnLabel: 'Sütun:',
      filterLabel: 'Filtre:',
      filterAll: 'Tümü',
      filterOnlyScanned: 'Sadece Tarananlar',
      filterNotScanned: 'Taranmayanlar',

      // Status messages
      notFound: '"{{value}}" bulunamadı!',
      marked: '"{{value}}" işaretlendi.',
      allHighlightsCleared: 'Tüm işaretlemeler temizlendi.',
      confirmDelete: 'Tüm veriler silinecek. Emin misiniz?',
      noDataFound: 'Gösterilecek veri bulunamadı',
      rowsShowing: '{{filtered}} / {{total}} satır gösteriliyor',

      // Column Settings
      columnSettings: 'Sütun Ayarları',
      searchColumn: 'Sütun ara...',
      selectAll: 'Tümünü Seç',
      deselectAll: 'Tümünü Kaldır',
      columnsCount: '{{visible}} / {{total}} sütun',

      // Export
      exportData: 'Dışa Aktar',
      exportSelectFilter: 'Hangi veriyi dışa aktarmak istiyorsunuz?',
      exportAll: 'Tümü ({{count}})',
      exportScanned: 'Tarananlar',
      exportNotScanned: 'Taranmayanlar',
      exportSelectFormat: 'Format seçin',
      exportXLSX: 'Excel (.xlsx)',
      exportXLS: 'Excel (.xls)',
      exportCSV: 'CSV (.csv)',
      exportSuccess: '{{count}} satır {{format}} olarak dışa aktarıldı.',

      // Language
      language: 'Dil',
    }
  },
  en: {
    translation: {
      // Upload Screen
      appTitle: 'Excel Editor',
      uploadSubtitle: 'Upload your Excel file, view and manage your data',
      dropText: 'Drag your file here',
      dropOr: 'or',
      selectFile: 'Select File',
      supportedFiles: '.xlsx, .xls, .csv files are supported',
      readingFile: 'Reading file...',
      invalidFileType: 'Please upload a valid Excel file (.xlsx, .xls, .csv).',
      emptyFile: 'The Excel file is empty or could not be read.',
      readError: 'Error reading file: {{message}}',

      // Features
      featureTableTitle: 'Table View',
      featureTableDesc: 'View your data in a clean, organized table',
      featureBarcodeTitle: 'Barcode Scanning',
      featureBarcodeDesc: 'Search and filter by column',
      featureSettingsTitle: 'Column Settings',
      featureSettingsDesc: 'Customize which columns you want to see',
      featureAutoSaveTitle: 'Auto Save',
      featureAutoSaveDesc: 'All data is securely stored in your browser',

      // Stats
      totalData: 'Total Data',
      scanned: 'Scanned',
      notScanned: 'Not Scanned',

      // Toolbar
      deleteData: 'Delete Data',
      searchPlaceholder: 'Enter value and press Enter...',
      clear: 'Clear',
      columnLabel: 'Column:',
      filterLabel: 'Filter:',
      filterAll: 'All',
      filterOnlyScanned: 'Scanned Only',
      filterNotScanned: 'Not Scanned',

      // Status messages
      notFound: '"{{value}}" not found!',
      marked: '"{{value}}" marked.',
      allHighlightsCleared: 'All highlights cleared.',
      confirmDelete: 'All data will be deleted. Are you sure?',
      noDataFound: 'No data to display',
      rowsShowing: '{{filtered}} / {{total}} rows showing',

      // Column Settings
      columnSettings: 'Column Settings',
      searchColumn: 'Search column...',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      columnsCount: '{{visible}} / {{total}} columns',

      // Export
      exportData: 'Export',
      exportSelectFilter: 'Which data do you want to export?',
      exportAll: 'All ({{count}})',
      exportScanned: 'Scanned',
      exportNotScanned: 'Not Scanned',
      exportSelectFormat: 'Select format',
      exportXLSX: 'Excel (.xlsx)',
      exportXLS: 'Excel (.xls)',
      exportCSV: 'CSV (.csv)',
      exportSuccess: '{{count}} rows exported as {{format}}.',

      // Language
      language: 'Language',
    }
  }
};

const savedLang = localStorage.getItem('appLanguage') || 'tr';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
